import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { processGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Call backend to exchange code
        await processGoogleCallback();

        toast.success('Successfully signed in with Google!');
        navigate('/dashboard', { replace: true });

      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error(error.message || 'Authentication failed. Please try again.');
        
        // Small delay so user can see the error toast
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 1500);
      }
    };

    processCallback();
  }, [processGoogleCallback, navigate]);

  return (
    <div className="min-h-screen bg-[#FFFBEB] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#08513F] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#264653] font-medium">Completing Google sign in...</p>
        <p className="text-sm text-gray-600 mt-2">Please wait</p>
      </div>
    </div>
  );
}